/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dlh_AllInputs */

const en_wc_dlh_all = /** @type {(inputs: Wc_Dlh_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download guide, installation steps and checksums`)
};

/**
* | output |
* | --- |
* | "Download guide, installation steps and checksums" |
*
* @param {Wc_Dlh_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dlh_all = /** @type {((inputs?: Wc_Dlh_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dlh_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dlh_all(inputs)
});
export { wc_dlh_all as "wc.dlh.all" }